import React from 'react';
import {gql} from "apollo-boost";
import {useQuery} from '@apollo/react-hooks';

export const SubContacts = {
    query: gql`query Contacts($parent_id: Int!) {
        contacts(
            count      : 9999 # paginator
            parent_id : $parent_id    # where
            orderBy    : [
                { field : "company_name", order : ASC },
                { field : "first_name", order : ASC },
                { field : "last_name", order : ASC }
            ]
        ){ data {
            id
            is_company
            company_name
            first_name
            last_name
            contact_type
            landline
            mobile
            email
            description # select
        } } }`,
};
